import { createContext } from 'react';

const WaveSurferContext = createContext(null);

export { WaveSurferContext as default };
